import { Tabs, Tooltip } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import emptyStateImage from '../../../../../../../../assets/images/compositions/empty-big.svg'
import configuration from '../../../../../../../configuration'
import Button from '../../../../../../../core/components/Button/Button'
import EmptyScreen from '../../../../../../../core/components/EmptyScreen/EmptyScreen'
import PROJECTION from '../../../../../../../core/constants/projections'
import { Nested, Percentage } from '../index'
import _ from 'lodash'
import Flat from '../Flat'

const TabsTables = (props) => {
  const {
    tabKey,
    setTabKey,
    canUserABM,
    isDisable,
    forecastInstanceDetail,
    onConfirmDeletSelection,
    isDataLoading,
    dataPhase,
    dataPeriod,
    isTableNestedLoading,
    reloadTableNested,
    isFinished,
    businessRuleId,
    setBusinessRuleId,
    setRuleTypeValue,
    ruleTypeValue,
    ruleList,
    reloadTablePercentage,
    setData,
    comments,
    onRefetchComments,
    loading,
    showProgressBar,
    visibleTotal = true,
    showTableqp,
    setShowTableqp,
    setShowAlert,
    settingsNested,
    settingsPercentage,
    setSettingsNested,
    setSettingsPercentage,
  } = props

  const enabled = true
  const enabledAbFlat = true
  const [exist, setExist] = useState(false)
  const { t } = useTranslation()
  let { periodId, forecastId } = useParams()
  let history = useHistory()

  const renderNoDataScreen = () => (
    <EmptyScreen
      image={emptyStateImage}
      title={t('CONFIG_FORMULAS_EMPTY_SCREEN_TITLE')}
      description={t('CONFIG_FORMULAS_EMPTY_SCREEN_DESCRIPTION')}
      footer={
        <Button.Primary
          onClick={() => history.push('/configuracion/herramientas/')}
          title="ACTION_GO_TO_CONFIGURE"
        />
      }
    />
  )

  const handleClick = (key) => {
    setTabKey(key)
    localStorage.removeItem('dataTable')
    setExist(false)
    window.history.replaceState(
      null,
      '',
      `/forecast/${periodId}/${forecastId}/${forecastInstanceDetail?.concept_name}/${forecastInstanceDetail?.id}/${dataPhase.key}/${key}`,
    )
  }

  return (
    <Tabs defaultActiveKey={tabKey} onChange={(key) => handleClick(key)} size="small">
      <Tabs.TabPane
        tab={
          <Tooltip title={t('PLANNING_TRANSACTIONAL_TABLE_INFORMATIVE_TOOLTIP_TITLE')}>
            {t('FIELD_TAB_TRANSACTIONAL')}
          </Tooltip>
        }
        key={PROJECTION.PLANNING_KEYS.TRANSACTIONAL_KEY}
      >
        {tabKey === PROJECTION.PLANNING_KEYS.TRANSACTIONAL_KEY && (
          <Nested
            disabledDeleteSelection={!canUserABM || forecastInstanceDetail?.is_closing || isDisable}
            onConfirmDeletSelection={onConfirmDeletSelection}
            loading={isDataLoading}
            dataPhase={dataPhase}
            forecastInstanceDetail={forecastInstanceDetail}
            dataPeriod={dataPeriod}
            tableLoading={isTableNestedLoading}
            reloadTableNested={reloadTableNested}
            canDelete={
              canUserABM && !isFinished && !forecastInstanceDetail?.is_closing && !isDisable
            }
            setData={setData}
            comments={comments}
            onRefetchComments={onRefetchComments}
            loadingComments={loading}
            showProgressBar={showProgressBar}
            visibleTotal={visibleTotal}
            tabKey={tabKey}
            showTableqp={showTableqp}
            setShowTableqp={setShowTableqp}
            setShowAlert={setShowAlert}
            exist={exist}
            setExist={setExist}
            settings={settingsNested}
            setSettings={setSettingsNested}
          />
        )}
      </Tabs.TabPane>
      {enabled && (
        <Tabs.TabPane
          tab={
            <Tooltip title={t('PLANNING_PERCENTAGE_TABLE_INFORMATIVE_TOOLTIP_TITLE')}>
              {t('FIELD_TAB_PERCENTAGE')}
            </Tooltip>
          }
          key={PROJECTION.PLANNING_KEYS.PERCENTAGE_KEY}
        >
          {tabKey === PROJECTION.PLANNING_KEYS.PERCENTAGE_KEY && businessRuleId !== undefined && (
            <Percentage
              loading={isTableNestedLoading}
              dataPhase={dataPhase}
              forecastInstance={forecastInstanceDetail}
              reloadTablePercentage={reloadTablePercentage}
              currentRdnSelect={businessRuleId}
              businessRulesOption={ruleList.values.filter((el) => el.formula_type === 'individual')}
              handleRdnChange={(id) => {
                const type_value = ruleList.values.find((el) => el.id === id).type_value
                setBusinessRuleId(id)
                setRuleTypeValue(type_value)
              }}
              ruleTypeValue={ruleTypeValue}
              setData={setData}
              comments={comments}
              onRefetchComments={onRefetchComments}
              loadingComments={loading}
              showProgressBar={showProgressBar}
              canUserABM={canUserABM}
              tabKey={tabKey}
              showTableqp={showTableqp}
              setShowTableqp={setShowTableqp}
              setShowAlert={setShowAlert}
              settings={settingsPercentage}
              setSettings={setSettingsPercentage}
            />
          )}
          {tabKey === PROJECTION.PLANNING_KEYS.PERCENTAGE_KEY &&
            businessRuleId === undefined &&
            renderNoDataScreen()}
        </Tabs.TabPane>
      )}

      {enabledAbFlat && (
        <Tabs.TabPane
          tab={
            <Tooltip title={t('PLANNING_FLAT_TABLE_INFORMATIVE_TOOLTIP_TITLE')}>
              {t('FIELD_TAB_FLAT')}
            </Tooltip>
          }
          key={PROJECTION.PLANNING_KEYS.FLAT_KEY}
        >
          {tabKey === PROJECTION.PLANNING_KEYS.FLAT_KEY && (
            <Flat
              periodId={dataPeriod?.id}
              forecastId={!_.isEmpty(forecastInstanceDetail) ? forecastInstanceDetail?.id : null}
              step={dataPhase.key}
            />
          )}
        </Tabs.TabPane>
      )}
    </Tabs>
  )
}

const mapStateToProps = (state) => ({
  ruleList: configuration.selectors.getRulesList(state),
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(TabsTables)
